<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<h2>Reservations Balance Due</h2>

<div class="reservationsTable">
  <p-table #pt [value]="reservations" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50,100,200]"
    [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"  [multiSortMeta]="multiSortMeta"
    selectionMode="single" [globalFilterFields]="['guestProfileVO.lastName','guestProfileVO.firstName','guestProfileVO.emailAddress','reservationId','orderId','reservationConfId','saleDate','checkInDate','checkOutDate','shortTermRentalVO.propertyCode','orderVO.orderIdMask', 'confirmationNumber']"
    [filterDelay]="1000" [(selection)]=" reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)" showCurrentPageReport="true"
    [loading]="loading" [responsive]="true" styleClass="p-datatable-striped" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" showJumpToPageInput="true">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between">
        <div class="mr-2">
          <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
              placeholder="Search" />
          </span>
          <button pButton pRipple class="ml-3 p-button-text"
            style="font-size: 100%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onAdvanceSearch()">Advanced Search</button>

          <!-- <button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash"
        (click)="clear(pt);"></button> -->
      </div>
      <!-- <div class="mr-2">
      <span class="p-input-icon-right">
        <i class="pi pi-search"></i>
        <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
          placeholder="Search" />
      </span>
    </div> -->
    <div class="d-block text-end">
      <span>
        <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50" [dataRetrived]="reservations"
        (exportDataSelected)="exportSelected($event)" importEnabled="false" [sampleFileLink]="sampleLink" [columns]="columns" [importDisabled]="true"></app-import-export>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <button pButton pRipple class="p-button-text" title="If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907."
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="openHelpAlert()">Need Help?</button>

        <!--add new-->
        <!-- <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      routerLink="/reservation-add">New Reservation +</button> -->
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      (click)="openCreateReservationPopUp()">New Reservation +</button>
    </span>
  </div>
</div>
</ng-template>
<ng-template pTemplate="header">
  <tr>

    <th [pSortableColumn]="'reservationStatus'">Status
      <p-sortIcon [field]="reservationStatus"></p-sortIcon>
    </th>

    <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Unit
      <p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'guestProfileVO.lastName'">Name
      <p-sortIcon [field]="'guestProfileVO.lastName'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'checkInDateTime'">In
      <p-sortIcon [field]="checkInDateTime"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'checkOutDateTime'">Out
      <p-sortIcon [field]="checkOutDateTime"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'numberOfNightsStay'">Nights
      <p-sortIcon [field]="numberOfNightsStay"></p-sortIcon>
    </th>
    <!--<th [pSortableColumn]="'numAdults'">Guests
    <p-sortIcon [field]="numAdults"></p-sortIcon>
  </th>-->
  <th>Invoice Total</th>
  <th>Payment Received</th>
  <th>Outstanding Balance</th>
  <!--<th [pSortableColumn]="'createDate'">Created
  <p-sortIcon [field]="createDate"></p-sortIcon>
</th>-->
<!--<th [pSortableColumn]="'reservationHoldExpiration'">Hold Expiration
<p-sortIcon [field]="reservationHoldExpiration"></p-sortIcon>
</th>-->
<th [pSortableColumn]="'orderVO.orderId'">Order #
  <p-sortIcon [field]="'orderVO.orderId'"></p-sortIcon>
</th>
<th [pSortableColumn]="'reservationId'">Res #
  <p-sortIcon [field]="reservationId"></p-sortIcon>
</th>
<!--<th [pSortableColumn]="'orderVO?.creditSaleToUserVO?.lastName'">Sales Agent Name
<p-sortIcon [field]="orderVO?.creditSaleToUserVO?.lastName"></p-sortIcon>
</th>-->
<th>Channel
</th>
<th>Action</th>
</tr>
<tr>
  <th>
    <p-multiSelect [options]="constantService.reservationStatuses" defaultLabel="Status"
    (onChange)="pt.filter($event.value, 'reservationStatus', 'in')" appendTo="body"></p-multiSelect>
  </th>

  <th>
    <input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'startsWith')">
  </th>
  <th>
    <input pInputText style="width:150px;" type="text"
      (input)="pt.filter($event.target.value, 'guestProfileVO.lastName', 'startsWith')">
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  (input)="pt.filter($event.target.value, 'checkInDateTime', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  (input)="pt.filter($event.target.value, 'checkOutDateTime', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
  (input)="pt.filter($event.target.value, 'numberOfNightsStay', 'contains')"></th>
  <!--<th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
(input)="pt.filter($event.target.value, 'numAdults', 'contains')"></th>-->
<th [ngStyle]="{'width': 'auto'}"></th>
<th [ngStyle]="{'width': 'auto'}"></th>
<th [ngStyle]="{'width': 'auto'}"></th>
<!--<th [ngStyle]="{'width': 'auto'}"></th>-->
<th>
  <input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'orderVO.orderId', 'contains')">
</th>
<th>
  <input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'reservationId', 'contains')">
</th>
<!--<th>
<input pInputText style="width:100px;" type="text"
  (input)="pt.filter($event.target.value, 'orderVO.creditSaleToUserVO.lastName', 'contains')">
</th>-->
<th>
  <p-multiSelect [options]="constantService.refSrcImages" defaultLabel="Channel"
  (onChange)="pt.filter($event.value, 'orderVO.referralSourceId', 'in')" appendTo="body"></p-multiSelect>
</th>
<th [ngStyle]="{'width': 'auto'}"></th>
</tr>
</ng-template>

<ng-template pTemplate="body" let-reservation>
  <tr [pSelectableRow]="reservation">
    <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
    {{getResStatusName(reservation.reservationStatus)}}</td>

    <td>{{reservation.propertyCode}}</td>
    <td><b>{{reservation.guestLastName}}</b></td>
    <td style="white-space: nowrap;">{{reservation.checkInDate|date:'MM/dd/yy EEEEEE'}}</td>
    <td style="white-space: nowrap;">{{reservation.checkOutDate|date:'MM/dd/yy EEEEEE'}}</td>
    <td style="text-align: center;">{{reservation?.numNights}}</td>
    <!--<td>{{reservation?.numAdults}}/{{reservation?.numChildren}} {{reservation?.numPets}}</td>-->
    <td>{{reservation.invoiceTotal|currency}}</td>
    <td>{{reservation.paymentReceived|currency}}</td>
    <td>{{reservation.outStandingBalance|currency}}</td>
    <!--<td>{{reservation.createDate|date:'MM/dd/yy'}}</td>-->
    <!--<td>{{reservation.holdExpiration|date:'MM/dd HH:MM'}}</td>-->
    <td>{{reservation.orderId}} </td>
    <td>{{reservation.reservationId}}</td>
    <!--<td>{{reservation.salesAgentLastName}}</td>-->
    <td><img style='height: 23px; width: 80px' src='{{constantService.getChannelPictureURL(reservation.referralSourceId)}}'/></td>
    <td><span style="float:none">
      <a>
        <mat-icon style="color:blue; font-size:110%; padding-right:20px;" title="Send Balance Due Reminder Email"
        (click)="sendReservationBalanceDueEmail(reservation)">email</mat-icon>
      </a>
      <a>
        <mat-icon style="color:blue; font-size:110%; padding-right:20px;" title="Run Payment"
        (click)="runAutoPayment(reservation)">attach_money</mat-icon>
      </a>
    </span>
  </td>
</tr>
</ng-template>
<ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
  {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>
</div>
